var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0767 17.6029C10.4433 17.9695 11.0377 17.9694 11.4043 17.6028C11.7707 17.2364 11.771 16.6424 11.4049 16.2757L8.07499 12.9396H18.5879C19.1077 12.9396 19.5291 12.5183 19.5291 11.9985C19.5291 11.4787 19.1077 11.0573 18.5879 11.0573H8.07499L11.4052 7.71925C11.7712 7.35246 11.7708 6.75856 11.4045 6.39219C11.0378 6.02552 10.4433 6.02552 10.0766 6.39219L5.35779 11.111C4.86766 11.6011 4.86772 12.3958 5.35794 12.8858L10.0767 17.6029Z",
    fill: "#0069AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackArrow);
export default __webpack_public_path__ + "static/media/blue-back-arrow.d3d813b3ae025d0cd623432c9dd48e8d.svg";
export { ForwardRef as ReactComponent };